module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b420cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/default.vue
// module id = 293
// module chunks = 25